import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    GetPaymentRequestsParams,
    GetPaymentRequestsResponse,
    GetPaymentRequestsBalanceResponse,
    GetWaybillByPaymentRequestResponse,
    GetPaymentRequestsStatisticsResponse
} from './types/payment-requests.types'

type ApiGetBalanceResponse = Promise<AxiosResponse<GetPaymentRequestsBalanceResponse>>
type ApiDepositBalanceResponse = Promise<AxiosResponse<void>>
type ApiGetPaymentRequestsResponse = Promise<AxiosResponse<GetPaymentRequestsResponse>>
type ApiPayPaymentRequestResponse = Promise<AxiosResponse<void>>
type ApiDeclinePaymentRequestResponse = Promise<AxiosResponse<void>>
type ApiGetWaybillByPaymentRequestResponse = Promise<AxiosResponse<GetWaybillByPaymentRequestResponse>>
type ApiGetPaymentRequestsStatisticsResponse = Promise<AxiosResponse<GetPaymentRequestsStatisticsResponse>>

export function getBalance(): ApiGetBalanceResponse {
    return http.get('/billing/api/balance')
}

export function depositBalance(payload: FormData): ApiDepositBalanceResponse {
    return http.postFormData('/billing/api/deposit', payload)
}

export function getPaymentRequests(params: GetPaymentRequestsParams): ApiGetPaymentRequestsResponse {
    return http.get('/billing/api/payments', { params })
}

export function payPaymentRequest(paymentRequestId: number, payload: FormData): ApiPayPaymentRequestResponse {
    return http.postFormData(`/billing/api/payments/${paymentRequestId}/pay`, payload)
}

export function declinePaymentRequest(paymentRequestId: number): ApiDeclinePaymentRequestResponse {
    return http.post(`/billing/api/payments/${paymentRequestId}/decline`, null)
}

export function getWaybillByPaymentRequest(paymentRequestId: number): ApiGetWaybillByPaymentRequestResponse {
    return http.get(`/dispatcher/api/waybills-by-payment/${paymentRequestId}`)
}

export function getPaymentRequestsStatistics(): ApiGetPaymentRequestsStatisticsResponse {
    return http.get('/billing/api/payments/count')
}

export default {
    getBalance,
    depositBalance,
    getPaymentRequests,
    payPaymentRequest,
    declinePaymentRequest,
    getWaybillByPaymentRequest,
    getPaymentRequestsStatistics
}
